module.exports = __webpack_public_path__ + "img/c5.4e8a3ca1.jpg";